import { RouteObject } from "react-router-dom";
import { R_OnBoardingRoutes } from "../../utils/Routes";
import { lazy } from "react";
import SuspenseWrapper from "../../components/CustomLazyLoading/CustomLazyLoading";
const FeatureOnBoarding = lazy(() => import("./Feature_OnBoarding"));

const OnBoardingRoutes: RouteObject[] = [
  {
    path: R_OnBoardingRoutes.onboarding,
    element: <SuspenseWrapper LazyLoadingComponent={FeatureOnBoarding} />,
  },
];

export default OnBoardingRoutes;
